import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { TimeZoneLocalizationService } from 'app/modules/main/services/time-zone-localization.service';
import { AdvertiserTimeZoneState } from 'app/modules/main/store/advertiser-time-zone/advertiser-time-zone.state';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AdvertiserTimeZoneSelectors {

  static readonly FEATURE = 'AdvertiserTimeZone';

  private readonly feature = createFeatureSelector<AdvertiserTimeZoneState>(
    AdvertiserTimeZoneSelectors.FEATURE
  );

  private readonly timeZone = createSelector(
    this.feature,
    (state: AdvertiserTimeZoneState) => state.timeZone
  );

  private readonly timeZoneName = createSelector(
    this.feature,
    (state: AdvertiserTimeZoneState) => state.timeZoneName
  );

  private readonly timeZoneLoaded = createSelector(
    this.feature,
    (state: AdvertiserTimeZoneState) => state.timeZoneLoaded
  );

  constructor(
    private readonly store: Store<AdvertiserTimeZoneState>,
    private readonly timeZoneLocalizationService: TimeZoneLocalizationService,
  ) {
  }

  public hasTimeZoneLoaded(): Observable<boolean> {
    return this.store.select(this.timeZoneLoaded);
  }

  public onTimeZoneLoaded(): Observable<boolean> {

    return this.hasTimeZoneLoaded()
      .pipe(filter(x => !!x));
  }

  public getTimeZone(): Observable<string> {

    return this.onTimeZoneLoaded()
      .pipe(switchMap(() => this.store.select(this.timeZone)));
  }

  public getTimeZoneLabel(): Observable<string> {

    return this.onTimeZoneLoaded()
      .pipe(
        switchMap(() => this.store.select(this.timeZoneName)),
        map(timeZoneName => this.timeZoneLocalizationService.localizeName(timeZoneName)),
      );
  }

}
